<template>
  <div>
    <div>
      <div class="grid">
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Floor") }}:</span>
          <p-vue-input-text v-model="apartmentLocal.Floor" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("rooms number") }}:</span>
          <p-vue-input-text v-model="apartmentLocal.RoomsNum" />
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Property type") }}:</span>
          <p-vue-dropdown
            :options="UnitTypes"
            :optionLabel="'UnitType'"
            :filter="UnitTypes.length > 10"
            v-model="apartmentLocal.UTypeValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.UnitType : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Payment methods") }}:</span>
          <p-vue-dropdown
            :options="UnitPaymentTypes"
            :optionLabel="'PayMentType'"
            :filter="UnitPaymentTypes.length > 10"
            v-model="apartmentLocal.PaymentTypeValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.PayMentType : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Management type") }}:</span>
          <p-vue-dropdown
            :options="UnitManagementTypes"
            :optionLabel="'ManagementType'"
            :filter="UnitManagementTypes.length > 10"
            v-model="apartmentLocal.ManagementTypeValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.ManagementType : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Area") }}:</span>
          <p-vue-input-text v-model="apartmentLocal.Size" />
          <!-- <p-vue-input-number v-model="apartmentLocal.Size" :suffix=" __('מ')" /> -->
        </div>
        <div class="p-d-flex p-flex-column p-mt-2">
          <span>{{ __("Warehouse space") }}:</span>
          <p-vue-input-text v-model="apartmentLocal.Storage" />
        </div>
      </div>
    </div>
    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Save')"
        @click="save"
      />
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Cancel')"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n";
import { apiParam, apiPType, callProc } from "@/services/APointAPI";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { mapState } from "vuex";
export default {
  props: {
    apartment: Object,
    close: Function,
  },
  emits: ["UnitUpdate"],
  data() {
    return {
      apartmentLocal: {},
      UnitTypes: [],
      UnitPaymentTypes: [],
      UnitManagementTypes: [],
    };
  },
  mounted() {
    this.apartmentLocal = this.apartment;
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("UserNum", this.userNum, apiPType.Int)];
      callProc("WorkerApp_UpdateUnitData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.UnitTypes = result.Table1;
          this.UnitPaymentTypes = result.Table;
          this.UnitManagementTypes = result.Table2;

          this.apartmentLocal.UTypeValue = this.UnitTypes.find(
            (f) => f.UTID == this.apartmentLocal.UType
          );
          this.apartmentLocal.PaymentTypeValue = this.UnitPaymentTypes.find(
            (f) => f.PayTID == this.apartmentLocal.PaymentType
          );
          this.apartmentLocal.ManagementTypeValue = this.UnitManagementTypes.find(
            (f) => f.UMID == this.apartmentLocal.ManagementType
          );
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateUnitData");
        });
    },
    save() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("BID", this.apartmentLocal.BID, apiPType.Int),
        apiParam("UID", this.apartmentLocal.UID, apiPType.Int),
        apiParam("Floor", this.apartmentLocal.Floor, apiPType.NVarChar),
        apiParam("Storage", this.apartmentLocal.Storage, apiPType.NVarChar),
        apiParam("Size", this.apartmentLocal.Size, apiPType.Real),
        apiParam("Rooms", this.apartmentLocal.RoomsNum, apiPType.Real),
        apiParam(
          "UType",
          this.apartmentLocal.UTypeValue.UnitType,
          apiPType.NVarChar
        ),
        apiParam(
          "PaymentType",
          this.apartmentLocal.PaymentTypeValue.PayTID,
          apiPType.Int
        ),
        apiParam(
          "ManagementType",
          this.apartmentLocal.ManagementTypeValue.UMID,
          apiPType.Int
        ),
      ];
      callProc("WorkerApp_UpdateUnit", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            this.apartmentLocal.UType = this.apartmentLocal.UTypeValue.UTID;
            this.apartmentLocal.UTypeName = this.apartmentLocal.UTypeValue.UnitType;
            this.apartmentLocal.ManagementType = this.apartmentLocal.ManagementTypeValue.UMID;
            this.apartmentLocal.ManagementTypeName = this.apartmentLocal.ManagementTypeValue.ManagementType;
            this.apartmentLocal.PaymentType = this.apartmentLocal.PaymentTypeValue.PayTID;
            this.apartmentLocal.PaymentTypeName = this.apartmentLocal.PaymentTypeValue.PayMentType;
            showSuccessOrFailedModal(__("Data saved successfully!"));
          } else {
            showSuccessOrFailedModal(__("An error occurred"), false);
          }
          setTimeout(() => {
            this.close();
          }, 2000);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateUnit");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
  align-items: center;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}
</style>
